<template>
  <div class="bg">
    <div class="top_search_part">
      <div class="search_box">
        <div class="goBackBox" @click="$router.go(-1)">
          <img class="goBackIcon" src="@/assets/backIcon.svg" />
          <span class="goBackTitle">{{$t('message.backText')}}</span>
        </div>
        <div class="search_item">
          <img src="@/assets/dateIcon.svg" style="margin-right: 10px;" />
          <span class="goBackTitle">{{date}}</span>
        </div>
      </div>
      <div class="add_btn" @click="createSignInImg">
        <img class="add_icon" src="@/assets/addIcon.svg" />
        <span>{{$t('message.createSignInImg')}}</span>
      </div>
    </div>
    <div class="content">
      <div class="tableBox">
        <el-table id="signInOrderImg" :data="signInOrderImg" style="width: 100%" stripe size="small"
         header-cell-class-name="tableHeader" cell-class-name="tableBodyer" v-loading="loading" height="100%">
          <el-table-column :label="$t('message.customTableTitle1')" prop="index" width="150"></el-table-column>
          <el-table-column :label="$t('message.signInImgName')" prop="originalfilename" min-width="100"></el-table-column>
          <el-table-column :label="$t('message.customTableTitle5')" width="300">
            <template slot-scope="scope">
              <el-link v-if="scope.row.imgurl.includes('.pdf')" type="primary" :underline="false" :href="scope.row.imgurl" target="_blank">{{$t('message.customTableContent')}}</el-link>
              <a v-else class="operation_a_blue" @click="checkSignInImg(scope.row.imgurl)">{{$t('message.customTableContent')}}</a>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="page_no"
        :page-sizes="pageSizes"
        :page-size="page_size"
        layout="total, sizes, prev, pager, next"
        :total="totalSize"
        class="tablePage">
      </el-pagination> -->
    </div>
    <!-- 上传签收单图片 -->
    <el-dialog :title="$t('message.createSignInImg')" :visible.sync="showUploadSignImg" width="40%" destroy-on-close :close-on-click-modal="false">
      <div class="dialog_box">
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.signInOrderCustomer')}}：</span>
            <el-select v-model="customerSel" multiple collapse-tags filterable style="margin-left: 20px;" :placeholder="$t('message.exportDatePlaceholder')">
              <el-option v-for="item in customerLsit" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item" style="display: flex;align-items: baseline;">
            <span class="dialog_item_title">{{$t('message.uploadFileTitle')}}：</span>
            <el-upload ref="upload" :action="uploadUrl" multiple :limit="9" :on-success="uploadSuccess" :on-remove="uploadRemove" style="margin-left: 20px;display: flex;align-items: baseline;">
              <el-button slot="trigger" size="small" type="primary">{{$t('message.uploadBtnText')}}</el-button>
            </el-upload>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showUpload = false">{{$t('message.cancleText')}}</el-button>
          <el-button type="primary" @click="uploadImgFile">{{$t('message.orderTemplateUploadTitle')}}</el-button>
        </span>
      </div>
    </el-dialog>
    <!-- 查看签收单图片 -->
    <el-dialog :title="$t('message.containerReceipt')" :visible.sync="showImgDialog" width="30%" destroy-on-close :close-on-click-modal="false">
      <div class="dialog_box">
        <el-image style="width: 100%;height: 100%" :src="imgUrl" :preview-src-list="srcList"></el-image>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { getSignInImgChekc, imgSrc, getCustomer, uploadImg, setSignInImg } from '@/api/getData.js'
  export default {
    name: 'signInImgList',
    data () {
      return {
        date: '',
        loading: false,
        signInOrderImg: [], // 签收单图片列表
        page_no: 1,
        page_size: 10,
        totalSize: 0,
        pageSizes: [10, 20, 50, 100, 200, 500],
        showUploadSignImg: false,
        customerLsit: [], // 客户列表
        customerSel: [], // 客户选择列表
        uploadFile: [], // 上传图片列表
        showImgDialog: false,
        imgUrl: '',
        srcList: []
      }
    },
    mounted() {
      this.date = this.$route.params.date
      this.getSignInImgChekc()
      let userid = this.$store.state.JHSS.personalUserid
      if (userid.includes('admin')) {
        this.getCuetomer()
      } else {
        this.customerLsit = [{
          label: this.$store.state.JHSS.personalAccount,
          value: this.$store.state.JHSS.personalUserid
        }]
      }
    },
    methods: {
      // 查询客户列表
      async getCuetomer () {
        let param = { IFQUERY: '1' }
        let res = await getCustomer(param)
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        } else {
          // console.log(res.data.dt)
          this.customerLsit = res.data.dt.map(item => {
            return {
              label: item.USHOWNAME + '——' + item.GUDING1,
              value: item.USERID
            }
          })
        }
      },
      // 查询签收单图片列表
      async getSignInImgChekc () {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading'
        })
        let param = { USERID: this.$store.state.JHSS.personalUserid, DATASTR: this.date }
        let res = await getSignInImgChekc(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        } else {
          // console.log(res.data)
          // this.totalSize = res.data.num
          // let index = (this.page_no - 1) * this.page_size
          this.signInOrderImg = []
          this.srcList = []
          res.data.dt.forEach(item => {
            // item.index = ++index
            this.signInOrderImg = this.signInOrderImg.concat(JSON.parse(item.QSD))
          })
          let index = 0
          this.signInOrderImg.forEach(item => {
            item.imgurl = imgSrc(item.filename)
            item.index = ++index
            if (!item.imgurl.includes('.pdf')) {
              this.srcList.push(item.imgurl)
            }
          })
        }
      },
      sizeChange (val) {
        this.page_size = val
        this.searchFun()
      },
      currentChange (val) {
        this.searchFun(val)
      },
      searchFun (val) {
        this.page_no = val || 1
        this.getSignInImgChekc()
      },
      // 创建签收单
      createSignInImg () {
        this.customerSel = []
        this.uploadFile = []
        this.showUploadSignImg = true
      },
      // 上传成功
      async uploadSuccess (file) {
        console.log(file)
        if (file.result !== '1') {
          this.$message.error('UPLOAD ERROR')
        } else {
          this.uploadFile.push({ filename: file.data.filename, originalfilename: file.data.fileoldname})
        }
      },
      // 移除成功
      uploadRemove (file) {
        let list = this.uploadFile.filter(item => {
          if (file.response.newFileName !== item.filename) {
            return item
          }
        })
        this.uploadFile = list
      },
      // 确定上传签收单图片
      async uploadImgFile () {
        if (this.customerSel.length === 0) {
          this.$message(this.$t('message.exportDatePlaceholder') + this.$t('message.signInOrderCustomer'))
          return
        }
        if (this.uploadFile.length === 0) {
          this.$message(this.$t('message.exportDatePlaceholder') + this.$t('message.uploadFileTitle'))
          return
        }
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading'
        })
        // let filename = this.uploadFile.map(item => {
        //   return item.filename
        // })
        // let originalfilename = this.uploadFile.map(item => {
        //   return item.originalfilename
        // })
        let param = {
          DATASTR: this.date,
          QSD: JSON.stringify(this.uploadFile),
          // QSD: filename.join(','),
          // OQSD: originalfilename.join(','),
          ADDUSER: this.$store.state.JHSS.personalUserid,
          CANSEEUSER: this.customerSel.join(',')
        }
        let res = await setSignInImg(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
        } else if (res.data.result !== '1') {
          this.$message.error(res.data.message)
        } else {
          this.$message.success('success')
          this.customerSel = []
          this.uploadFile = []
          this.showUploadSignImg = false
          this.searchFun()
        }
      },
      // 查看签收单图片
      checkSignInImg (imgurl) {
        this.imgUrl = imgurl
        this.showImgDialog = true
      }
    },
    computed: {
      uploadUrl () {
        return uploadImg()
      }
    }
  }
</script>

<style scoped>
</style>
